import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { InstallButton } from "@/components/common/Install";
import AuthShell from "@/pages/auth/AuthShell";
import { Field, TextInput } from "@/components/common/Forms";
import { useAuth, homeFor } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const from = useLocation().state?.from;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(email.trim(), password);
      nav(from && u.role === "center" ? from : homeFor(u), { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell>
      <div data-testid="register-callout" className="relative overflow-hidden rounded-2xl border border-gold/50 bg-gradient-to-br from-gold/[0.16] via-gold/[0.05] to-transparent p-5 sm:p-6 mb-10 shadow-[0_20px_60px_-25px_rgba(212,175,55,0.6)] animate-fade-up">
        <div className="pointer-events-none absolute -top-16 -right-16 w-44 h-44 rounded-full bg-gold/20 blur-3xl" />
        <p className="relative font-serif text-2xl sm:text-3xl leading-tight">Non sei ancora registrata a <em className="text-gold-gradient">My Skin Lovers</em>?</p>
        <p className="relative mt-2 text-sm text-white/80 leading-relaxed">Prima di accedere devi iscrivere il tuo centro. Il team Skin Lovers approva la richiesta e ti avvisa via email.</p>
        <Link to="/registrati" data-testid="register-link" className="relative btn-gold w-full mt-5">Richiedi l'iscrizione</Link>
      </div>
      <p className="eyebrow mb-4">Sei già iscritta?</p>
      <h1 className="text-4xl sm:text-5xl font-light leading-tight">Bentornata.</h1>
      <p className="mt-3 text-sm text-warm-text leading-relaxed">Accedi con l'email e la password del tuo centro.</p>
      <form onSubmit={submit} className="mt-10 space-y-6" data-testid="login-form">
        <Field label="Email"><TextInput data-testid="login-email-input" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></Field>
        <Field label="Password"><TextInput data-testid="login-password-input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></Field>
        {error && <p data-testid="login-error" className="text-sm text-destructive">{error}</p>}
        <button data-testid="login-submit-btn" disabled={busy} className="btn-ghost w-full">{busy ? "Accesso in corso…" : "Accedi"}</button>
        <div className="flex justify-between items-center pt-2">
          <Link to="/password-dimenticata" data-testid="forgot-password-link" className="btn-link">Password dimenticata?</Link>
        </div>
      </form>
      <div className="hairline mt-12 pt-8">
        <p className="text-sm text-warm-text">Il tuo centro non è ancora iscritto? <Link to="/registrati" data-testid="register-link-bottom" className="btn-link">Richiedi l'iscrizione</Link></p>
        <InstallButton className="btn-ghost w-full mt-6" label="Metti l'app sul telefono" testid="login-install-btn" />
      </div>
    </AuthShell>
  );
}
